import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericCrudService } from './generic-crud.service';
import { Response } from '../models/Response';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private baseUrl = '/product';

  constructor(private genericCrudService: GenericCrudService) { }

  getProduct(id: string): Observable<Response<any>> {
    return this.genericCrudService.list(`${this.baseUrl}/show/${id}`);
  }

  getProductsCount(): Observable<Response<any>> {
    return this.genericCrudService.list(`${this.baseUrl}/products-count`);
  }

  listAll(): Observable<Response<any[]>> {
    return this.genericCrudService.list(`${this.baseUrl}/index`);
  }

  // Métodos para gestión de tarifas del producto
  getProductPriceLists(productId: string): Observable<Response<any>> {
    return this.genericCrudService.list(`${this.baseUrl}/${productId}/price-list`);
  }

  assignPriceListToProduct(productId: string, priceListId: number, price: number): Observable<Response<any>> {
    return this.genericCrudService.reqByMethod(`${this.baseUrl}/${productId}/rates`, 'POST', { price_list_id: priceListId, price });
  }

  updateProductPriceListPrice(productId: string, priceListId: number, price: number): Observable<Response<any>> {
    return this.genericCrudService.reqByMethod(`${this.baseUrl}/${productId}/rates/${priceListId}`, 'PUT', { price });
  }

  removePriceListFromProduct(productId: string, priceListId: number): Observable<Response<any>> {
    return this.genericCrudService.reqByMethod(`${this.baseUrl}/${productId}/rates/${priceListId}`, 'DELETE');
  }
}
